import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=56fee2ae"
import script from "./page-footer.vue?vue&type=script&lang=ts"
export * from "./page-footer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56fee2ae')) {
      api.createRecord('56fee2ae', component.options)
    } else {
      api.reload('56fee2ae', component.options)
    }
    module.hot.accept("./page-footer.vue?vue&type=template&id=56fee2ae", function () {
      api.rerender('56fee2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/page-footer.vue"
export default component.exports